/**
 * Lost Modal Component
 */

import { Form, Input, Modal } from 'antd';
import React from 'react';

interface LostModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (remarks?: string) => void;
  isLoading?: boolean;
}

export const LostModal: React.FC<LostModalProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    const values = await form.validateFields();
    onConfirm(values.remarks);
    form.resetFields();
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Mark Quote as Lost"
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Confirm"
      cancelText="Cancel"
      confirmLoading={isLoading}
      width={500}
    >
      <Form form={form} layout="vertical">
        <p className="text-gray-600 mb-4">
          Are you sure you want to mark this quote as lost?
        </p>
        <Form.Item
          label="Remarks (Optional)"
          name="remarks"
        >
          <Input.TextArea
            rows={3}
            placeholder="Enter reason for marking as lost..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LostModal;
